import { SetStateAction, useEffect, useState } from 'react'
import { Input } from '../ui/Input'
import logo from '../../logo.png'
import { toast, ToastContainer } from 'react-toastify'
import { useLoginUser } from '../../hooks/db/useLogin'


export default function ResetPassword() {
  const [token, setToken] = useState('')
  const [isValidToken, setIsValidToken] = useState(false)
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [newUser, setNewUser] = useState(false)
  const { validateResetToken, resetUserPassword } = useLoginUser()

  const handleReset = async () => {
    setError('')
    if (!token) return setError('Invalid or expired reset link.')
    if (!password || password.length < 6) return setError('Password must be at least 6 characters.')
    if (password !== confirm) return setError('Passwords do not match.')

    setLoading(true)
    try {
      const result = await resetUserPassword(token, password)
      console.log("Password reset response", result.message);
      if (result.success) {
        toast.success(result.message, {
            position: "top-center",
            toastId: 'reset-token-error'
        })
        setSuccess(true)
        setPassword('')     
        setConfirm('')
        setIsValidToken(false)
        setToken('')
        // Optionally redirect to login page or home page
        setTimeout(() => {
            window.location.href = '/user-login';
        }, 2000);

        }else{
            toast.error(result.message, {
                position: "top-center",
                toastId: 'reset-token-error'
            })
        }
      
    } catch (err: any) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    const validateToken = async () => {
      const token =  new URLSearchParams(window.location.search).get('resetToken') || ''
      const newUser = new URLSearchParams(window.location.search).get('newUser') === 'true'
      setNewUser(newUser)
      if (token) {
        setToken(token)

        console.log('Reset token found:', token)
        // now validate the token with the backend
        const result = await validateResetToken(token)
        console.log('Token validation result:', result)
        if (!result.success) {
            console.log("Token validation failed:", result.message);
            toast.error(result.message, {
                position: "top-center",
                toastId: 'reset-token-error'
            });

        }else{
            setIsValidToken(true)
            console.log("Token is valid, you can reset your password now.");
        }
      }
    };
    validateToken();
  }, [])

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        handleReset()
      }}
      className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4"
    >
      <ToastContainer />
      <div className="w-full max-w-md p-6 bg-white dark:bg-gray-800 rounded-xl shadow-md">
        {success ? (
          <div className="text-center">
            <h2 className="text-xl font-semibold mb-2 text-green-600">Password Reset Successful!</h2>
            <p className="text-sm text-gray-600 dark:text-gray-300">You can now log in with your new password. Redirecting to the login page ..</p>
          </div>
        ) : (
          <>
            <div className="flex justify-center mb-4">
                <img src={logo} alt="Company Logo" className="h-18" />
            </div>
            <h2 className="text-2xl font-bold mb-4 text-center text-gray-800 dark:text-white">
              {newUser ? 'Create Password' : 'Reset Password'}
            </h2>

            <div className="mb-4">
              <Input
                type="password"
                value={password}
                onChange={(e: { target: { value: SetStateAction<string> } }) => setPassword(e.target.value)}
                placeholder="Enter new password"
                minLength={6}
                required
              />
            </div>

            <div className="mb-4">
              <Input
                type="password"
                value={confirm}
                onChange={(e: { target: { value: SetStateAction<string> } }) => setConfirm(e.target.value)}
                placeholder="Re-enter new password"
                minLength={6}
                required
              />
            </div>

            {error && <p className="text-red-600 text-sm mb-3">{error}</p>}

            {newUser &&
              <>
                <div className="mb-4 flex justify-center">
                    <input
                        type="checkbox"
                        id="terms"
                        className="mr-2"
                        required
                    />
                    <label htmlFor="terms" className="text-sm text-gray-700">
                        I agree to the{' '}
                        <a
                            href="/terms"
                            className="text-blue-500 hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Terms and Conditions
                        </a>
                        &nbsp;and&nbsp;
                        <a
                            href="/user-agreements"
                            className="text-blue-500 hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            User Agreement
                        </a>
                        
                    </label>
                </div>
              </>
            }

            <button
              type="submit"
              disabled={isValidToken ? loading : true}
              className={`btnLong w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-300` + (isValidToken ? '' : ' opacity-50 cursor-not-allowed')}
            >
              Submit
            </button>
          </>
        )}
      </div>
    </form>
  )
}

  